<template>
	<div class="map" id="map"></div>
</template>

<script>
	import axios from "axios";
	import L from "leaflet";

	export default {
		props: {
			id: String,
		},
		data: () => ({
			map: undefined,
			polyline: undefined,
			leafletRoute: [],
		}),
		methods: {
			initializeMap() {
				//Workaround for webpack not importing the icons
				delete L.Icon.Default.prototype._getIconUrl;

				L.Icon.Default.mergeOptions({
					iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
					iconUrl: require("leaflet/dist/images/marker-icon.png"),
					shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
				});
				//End of workaround

				//Create the map
				this.map = L.map(`map`, {
					zoomControl: false,
					attributionControl: false,
				}).setView([this.leafletRoute[0].x, this.leafletRoute[0].y], 13);

				//Then add the tile layer
				L.tileLayer(
					"https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
					{
						attribution: "OpenStreetMap | Mapbox",
						maxZoom: 21,
						id: "jesusjimenez/ckdljew0j267d1ikyckn7b1cj",
						tileSize: 512,
						zoomOffset: -1,
						accessToken: process.env.VUE_APP_MAP_TOKEN,
					}
				).addTo(this.map);

				L.control
					.attribution({
						position: "bottomleft",
					})
					.addTo(this.map);

				const markers = [];

				markers.push(
					L.marker(
						new L.LatLng(this.leafletRoute[0].x, this.leafletRoute[0].y)
					)
						.addTo(this.map)
						.bindTooltip("Inicio", {
							permanent: true,
							direction: "left",
						})
				);

				markers.push(
					L.marker(
						new L.LatLng(
							this.leafletRoute[this.leafletRoute.length - 1].x,
							this.leafletRoute[this.leafletRoute.length - 1].y
						)
					)
						.addTo(this.map)
						.bindTooltip("Fin", {
							permanent: true,
							direction: "right",
						})
				);

				this.polyline = new L.Polyline(
					this.leafletRoute.map((coord) => [coord.x, coord.y]),
					{
						color: "#bfaa7f",
						weight: 6,
						opacity: 1,
						smoothFactor: 1,
					}
				);

				this.polyline.addTo(this.map);

				this.map.fitBounds(this.polyline.getBounds(), {
					padding: [50, 50],
				});
			},
		},
		async mounted() {
			try {
				this.leafletRoute = (
					await axios.get(
						process.env.VUE_APP_BACK_URL + "/api/admin/race/" + this.id
					)
				).data.route;
				this.initializeMap();
			} catch (error) {
				console.error(error);
			}
		},
	};
</script>

<style lang="scss" scoped>
	.map {
		height: 100vh;
		width: 100vw;
	}
</style>